module.exports = {
  text: `Жизнь орков — это жизнь, посвященная богам. Лютик при рождении, Лютик при смерти и стремление показать себя перед Груумшем между ними`,
  author: `Эльминстер`,
}
